/**
 * After getplaycasino bootstraps a live-casino session, jump the iframe
 * to that provider's lobby SPA (same place as the in-game LOBBY button).
 *
 * Only Evolution supports a reliable lobby SPA jump without breaking the
 * launch token (Ezugi Error 2031 if tableId is rewritten).
 */

function providerKey(provider?: unknown): string {
  const p = String(provider || '').toLowerCase()
  if (/evolution/i.test(p)) return 'evolution'
  return ''
}

/** Providers where we can auto-open the lobby UI after session bootstrap. */
export function canAutoOpenProviderLobby(provider?: unknown): boolean {
  return providerKey(provider) === 'evolution'
}

/**
 * Build Evolution lobby SPA URL from a valid launch/session URL.
 * In-game LOBBY → /frontend/evo/r2/#category=all_games
 * Category lobbies → #category=baccarat | blackjack | poker | game_shows | …
 */
export function buildProviderLobbyUrl(
  fromUrl: string,
  provider?: unknown,
  evoCategory?: string | null,
): string | null {
  if (!fromUrl || !canAutoOpenProviderLobby(provider)) return null

  try {
    const u = new URL(fromUrl.trim())
    const host = u.hostname.toLowerCase()
    const looksEvo =
      /evo-games|evolutiongaming|egcvi|\.evo\./i.test(host) ||
      /\/frontend\/evo\//i.test(u.pathname)

    if (!looksEvo && providerKey(provider) !== 'evolution') return null

    const cat = String(evoCategory || 'all_games').trim() || 'all_games'
    return `${u.origin}/frontend/evo/r2/#category=${encodeURIComponent(cat)}`
  } catch {
    return null
  }
}

export function providerLobbyTitle(provider?: unknown): string {
  const p = String(provider || '').trim()
  return p ? `${p} Lobby` : 'Casino Lobby'
}
